module.exports = __webpack_public_path__ + "static/img/info.3e89518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floatingWindow/info.png
// module id = sYPC
// module chunks = 13